export class StorageConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "driverDiskSize",
            "baseName": "driverDiskSize",
            "type": "number",
            "format": ""
        },
        {
            "name": "executorDiskSize",
            "baseName": "executorDiskSize",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StorageConfig.attributeTypeMap;
    }
    constructor() {
    }
}
